import type { ClientMsg, ServerMsg } from '@realseas/shared';

export type MessageHandler = (msg: ServerMsg) => void;

export class Connection {
  private ws: WebSocket | null = null;
  private handler: MessageHandler;
  private url: string;

  constructor(handler: MessageHandler) {
    this.handler = handler;
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    this.url = `${protocol}//${window.location.host}`;
  }

  connect(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.ws = new WebSocket(this.url);
      const timeout = setTimeout(() => {
        if (this.ws && this.ws.readyState !== WebSocket.OPEN) {
          this.ws.close();
          reject(new Error('Connection timed out.'));
        }
      }, 5000);

      this.ws.onopen = () => { clearTimeout(timeout); resolve(); };
      this.ws.onmessage = (event) => {
        try {
          const msg: ServerMsg = JSON.parse(event.data);
          this.handler(msg);
        } catch {
          /* ignore malformed */
        }
      };
      this.ws.onerror = () => {
        clearTimeout(timeout);
        reject(new Error('Connection failed.'));
      };
      this.ws.onclose = () => {
        console.log('[Connection] Disconnected');
      };
    });
  }

  send(msg: ClientMsg): void {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(msg));
    }
  }
}
